/** A property decorated with this will have any value assigned
 * to it cast to a number with the unary `+` operator.
 */
export function castToNumber(): PropertyDecorator {
    return <T>(target: T, key: keyof T) => {
        const internalKey = `_${key}`;
        Object.defineProperties(target, {
            [internalKey]: {
                enumerable: false,
                configurable: true,
                writable: true,
                value: undefined
            },
            [key]: {
                enumerable: true,
                configurable: true,
                get(): number {
                    return this[internalKey];
                },
                set(newValue: string | number) {
                    this[internalKey] = +newValue;
                }
            }
        });
    };
}
